module.exports = __webpack_public_path__ + "static/media/789316407630621.38537e20.jpg";